import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchTaskById } from "../redux/Slices/TasksSlice";
import styles from "../Style/TaskDetails.module.css";
import dayjs from "dayjs";

function TaskDetails() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { tasks, error, status } = useSelector((state) => state.tasksReducer);

  useEffect(() => {
    if (id) {
      dispatch(fetchTaskById(id));
    }
  }, [dispatch, id]);

  if (status === "loading") {
    return <div>Loading task details...</div>;
  }

  if (status === "failed") {
    return <div>Error: {error}</div>;
  }

  const task = tasks.find((task) => task.id === id);

  if (!task) {
    return <div>No task details found for ID: {id}</div>;
  }

  return (
    <div className={styles.taskDetailsContainer}>
      <h2>Task Details</h2>
      <div className={styles.taskDetailRow}>
        <strong>ID:</strong> <span>{task.id}</span>
      </div>
      <div className={styles.taskDetailRow}>
        <strong>Task Name:</strong> {task.taskName}
      </div>
      <div className={styles.taskDetailRow}>
        <strong>Description :</strong> {task.description}
      </div>
      <div className={styles.taskDetailRow}>
        <strong>Category:</strong> {task.categories}
      </div>
      <div className={styles.taskDetailRow}>
        <strong>Status:</strong> {task.status}
      </div>
      <div className={styles.taskDetailRow}>
        <strong>Due Date:</strong>{" "}
        {task.duedate ? dayjs(task.duedate).format("YYYY/MM/DD") : "N/A"}
      </div>
      <div className={styles.taskDetailRow}>
        <strong>Created Date:</strong> {task.createddate}
      </div>
    </div>
  );
}

export default TaskDetails;
